import type { ReactNode, AnchorHTMLAttributes } from 'react';
import { useJustEatUrl } from '@/hooks/useJustEatUrl';

interface JustEatButtonProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  children: ReactNode;
  className?: string;
  /** Hide entirely when URL is empty (default true) */
  hideIfEmpty?: boolean;
}

/** External Just Eat CTA — renders nothing if URL is not configured */
const JustEatButton = ({
  children,
  className = '',
  hideIfEmpty = true,
  ...rest
}: JustEatButtonProps) => {
  const { url, hasUrl } = useJustEatUrl();

  if (!hasUrl && hideIfEmpty) return null;

  if (!hasUrl) {
    return (
      <span className={`${className} opacity-50 pointer-events-none`} aria-disabled>
        {children}
      </span>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      {...rest}
    >
      {children}
    </a>
  );
};

export default JustEatButton;
